// extracted by mini-css-extract-plugin
export default {"link":"HeaderLink_link__boFIP","invisible":"HeaderLink_invisible__QgglA"};